import { Box, Button, TextField } from "@mui/material";
import { useState } from "react";
import bulkHelpers from "../../helpers/bulk";

const HangTagAdmin = (props) => {

    const [skuSearchText, setSkuSearchText] = useState("");
    const [skuInfo, setSkuInfo] = useState(null);
    const [mode, setMode] = useState("");

    const searchSku = async () => {
        props.setLoading(true);
        try {
            setMode("update");
            const trimmedSku = skuSearchText.trim();
            const hangTag = await bulkHelpers.getHangTagBySku(trimmedSku, props.token);
            setSkuInfo(hangTag);
        } catch (error) {
            props.toast.error("Failed to retrieve hang tag information from IMS API. Please contact a developer");
            console.log(error);
        }
        props.setLoading(false);
    };

    const startNewSku = () => {
        setSkuSearchText("");
        setMode("create");
        setSkuInfo({
            sku: "",
            asin: "",
            amazon_description: "",
            size: "",
            color: "",
            upc: "",
            pretagged: "",
            care_instructions: "",
            chewy_sku: "",
            chewy_description: ""
        });
    };

    const updateSkuInfo = (fieldName, value) => {
        const newSkuInfo = {...skuInfo};
        newSkuInfo[fieldName] = value;
        setSkuInfo(newSkuInfo);
    };

    const saveSku = async () => {
        props.setLoading(true);
        try {
            if (mode === "update") {
                console.log("Updating existing SKU in hang tag table");
                await bulkHelpers.updateHangTag(skuInfo, props.token);
            } else if (mode === "create") {
                console.log("Inserting new SKU into hang tag table");
                await bulkHelpers.createNewHangTag(skuInfo, props.token);
            }
            props.toast.success("Successfully updated hang tag table");
        } catch (error) {
            console.log(error);
            props.toast.error("Failed to update hang tag table via IMS API");
        }
        props.setLoading(false);
    };

    const textFieldStyle = {
        width: "20%",
        marginTop: 1,
        marginBottom: 1
    };

    const textAreaStyle = {
        marginTop: 1,
        marginBottom: 1,
        width: "40%"
    };

    const buttonStyle = {
        display: "inline-block",
        maxWidth: 120,
        marginRight: 1,
        marginTop: 1,
        marginBottom: 4
    }

    return (
        <Box className={props.isMobile ? "mobile-top" : "desktop-top"} sx={{ display: 'flex', flexDirection: 'column', marginLeft: "1%", paddingLeft: "1%" }}>
            <h2>Hang Tag Admin</h2>
            <TextField sx={textFieldStyle} label="SKU" value={skuSearchText} onChange={(e) => setSkuSearchText(e.target.value)} />
            <div>
                <Button sx={buttonStyle} onClick={searchSku} variant="contained">Search</Button>
                <Button sx={buttonStyle} onClick={startNewSku} variant="contained">New</Button>
            </div>

            {skuInfo !== null && <>
                {mode === "update" && <h3>SKU: {skuInfo.sku}</h3>}
                {mode === "create" && <h3>New SKU</h3>}
                {mode === "create" && <TextField sx={textFieldStyle} label="SKU" value={skuInfo.sku} onChange={(e) => updateSkuInfo("sku", e.target.value)} />}
                <TextField sx={textFieldStyle} label="ASIN" value={skuInfo.asin} onChange={(e) => updateSkuInfo("asin", e.target.value)} />
                <TextField multiline minRows={2} sx={textAreaStyle} label="Amazon description" value={skuInfo.amazon_description} onChange={(e) => updateSkuInfo("amazon_description", e.target.value)} />
                <TextField sx={textFieldStyle} label="Size" value={skuInfo.size} onChange={(e) => updateSkuInfo("size", e.target.value)} />
                <TextField sx={textFieldStyle} label="Color" value={skuInfo.color} onChange={(e) => updateSkuInfo("color", e.target.value)} />
                <TextField sx={textFieldStyle} label="UPC" value={skuInfo.upc} onChange={(e) => updateSkuInfo("upc", e.target.value)} />
                <TextField sx={textFieldStyle} label="Pretagged" value={skuInfo.pretagged} onChange={(e) => updateSkuInfo("pretagged", e.target.value)} />
                <TextField multiline minRows={3} sx={textAreaStyle} label="Care instructions" value={skuInfo.care_instructions} onChange={(e) => updateSkuInfo("care_instructions", e.target.value)} />
                <TextField sx={textFieldStyle} label="Chewy SKU" value={skuInfo.chewy_sku} onChange={(e) => updateSkuInfo("chewy_sku", e.target.value)} />
                <TextField sx={textFieldStyle} label="Chewy description" value={skuInfo.chewy_description} onChange={(e) => updateSkuInfo("chewy_description", e.target.value)} />
                <Button sx={buttonStyle} onClick={saveSku} variant="contained">Save</Button>
            </>}

        </Box>
    );
};

export default HangTagAdmin;
